import { EntityQuery } from 'breeze-client';
import { UserPrincipal } from '../../models';

const baseQuery = EntityQuery.from('Users');

export const userQueries = {
  selectAll: baseQuery.orderBy(UserPrincipal.propNames('firstName', 'lastName')),
  selectExternalUsers: EntityQuery.from('ExternalUsers')
};
